import { render, staticRenderFns } from "./citationTrace.vue?vue&type=template&id=3bf431c8&scoped=true"
import script from "./citationTrace.vue?vue&type=script&lang=js"
export * from "./citationTrace.vue?vue&type=script&lang=js"
import style0 from "./citationTrace.vue?vue&type=style&index=0&id=3bf431c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf431c8",
  null
  
)

export default component.exports